import { useLang } from '@/i18n';
import { useProductStore } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import AccessoriesA from './components/AccessoriesA';
import Animation1 from './components/Animation1';
import Animation3D from './components/Animation3D';
import BannerA from './components/BannerA';
import BannerB from './components/BannerB';
import BarPromoA from './components/BarPromoA';
import BlackA from './components/BlackA';
import CompareA from './components/CompareA';
import FaqA from './components/FaqA';
import FooterTcA from './components/FooterTcA';
import ListA1 from './components/ListA1';
import ListA2 from './components/ListA2';
import ListB from './components/ListB';
import PageNavLeft, { Theme } from './components/PageNavLeft';
import SectionA from './components/SectionA';
import SectionB from './components/SectionB';
import SectionC from './components/SectionC';
import SectionD from './components/SectionD';
import UserListA from './components/UserListA';
import WhatInBoxA from './components/WhatInBoxA';

export default function NA_Product() {
    const { t } = useLang('theProduct.KSP');
    const { pageStatus } = useProductStore();
    const IS_Status_A = pageStatus === IPageStatus.statusA;
    const IS_Status_B = pageStatus === IPageStatus.statusB;
    return (
        <div className="ecoflow-wave-3-page">
            {IS_Status_A && (
                <>
                    <BarPromoA />
                    <BannerA />
                </>
            )}
            {IS_Status_B && <BannerB />}
            <div
                className="range1 GtmModuleData-section"
                data-section-id="range1-ListA1"
                data-section-classname="#ListA1 .eco-section-carousel .eco-section-title"
            >
                <ListA1 />
                {IS_Status_A && <SectionA />}
            </div>

            <Animation1 />
            <ListB />
            <SectionB />

            <BlackA />
            <div className="range4 GtmModuleData-section" data-section-id="ListA2" data-section-classname=".eco-section-title">
                <ListA2 />
            </div>
            <div className="range5 GtmModuleData-section" data-section-id="FaqA" data-section-classname=".eco-section-title">
                <FaqA />
            </div>
            {/* <div className="range6 GtmModuleData-section" data-section-id="SectionC" data-section-classname=".eco-section-title">
                <SectionC />
            </div> */}
            <div className="range7 GtmModuleData-section" data-section-id="SectionD" data-section-classname=".eco-section-title">
                <SectionD />
            </div>
            <UserListA />
            <div className="range8 GtmModuleData-section" data-section-id="Animation3D" data-section-classname="#Animation3d .title">
                <Animation3D />
            </div>
            <div className="range9 GtmModuleData-section" data-section-id="CompareA" data-section-classname=".eco-section-title">
                <CompareA />
            </div>
            <div className="range10 GtmModuleData-section" data-section-id="WhatInBoxA" data-section-classname=".eco-section-title">
                <WhatInBoxA />
            </div>
            <div className="range11 GtmModuleData-section" data-section-id="AccessoriesA" data-section-classname=".eco-accessories-title">
                {IS_Status_B && <AccessoriesA />}
            </div>
            <FooterTcA />
            <PageNavLeft
                triggerElement=".ecoflow-wave-3-page"
                steps={
                    [
                        { text: t('item1'), href: '#ListA1' },
                        { text: t('item2'), href: '#wave3-D-title' },
                        { text: t('item3'), href: '#screen3' },
                        { text: t('item4'), href: '#ListA2' },
                        { text: t('item5'), href: '#FaqA' },
                        { text: t('item6'), href: '#SectionC' },
                        { text: t('item7'), href: '#SectionD' },
                        { text: t('item8'), href: '#Animation3d' },
                        { text: t('item9'), href: '#CompareA' },
                        { text: t('item10'), href: '#WhatInBoxA' },
                        IS_Status_B && { text: t('item11'), href: '#AccessoriesA' },
                    ].filter(Boolean) as any
                }
                triggerElements={[
                    { selectors: '#SectionB', theme: Theme.black },
                    { selectors: '#range2', theme: Theme.black },
                    { selectors: '#range3', theme: Theme.white },
                    { selectors: '#ListB', theme: Theme.black },
                    { selectors: '#BlackA', theme: Theme.white },
                    { selectors: '#ListA2', theme: Theme.white },
                    { selectors: '#FaqA', theme: Theme.black },
                ]}
            />
        </div>
    );
}
